/* import __COLOCATED_TEMPLATE__ from './splash-svg.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();